import { computed, ref } from 'vue';
import { useLoadingStore } from 'SharedDir/stores/loading.store';

export function useLoadingSsr() {
  const isLoading = ref(true);
  const loadingStore = useLoadingStore();
  const showLoading = computed(() => loadingStore.getLoading);

  return {
    isLoading,
    showLoading,
    loadingStore
  };
}
